export function getCardTypePretty(cardType) {
  if (!cardType) return "";

  cardType = String(cardType).toLowerCase();

  switch (cardType) {
    case "amex":
      return "American Express";
    default: {
      const cardTypeCapitalized =
        cardType[0].toUpperCase() + cardType.substring(1);
      return cardTypeCapitalized;
    }
  }
}
